export default class CreateExtensionProjectCtrl {

  constructor ($scope, $timeout, $mdDialog, $stateParams, WorkPlanSrv, WorkPlanModalSrv, $cookies, GlobalConfig, GlobalSrv) {
    var createExtensionProjectVm = this
    const currentUser = JSON.parse($cookies.get('currentUser'))
    const texts = GlobalConfig.appTexts
    let post = {
      workplanId: currentUser.workplanId,
      teacherId: currentUser.teacherId,
      name: currentUser.name
    }

    createExtensionProjectVm.idParent = WorkPlanModalSrv.getVariable()
    createExtensionProjectVm.isEditing = Boolean($stateParams.workplanTeacherActivityId)
    createExtensionProjectVm.createOrEdit = 'Agregar'
    createExtensionProjectVm.textCreateOrEdit = texts.saved
    createExtensionProjectVm.createOrEditMV = texts.createDialog
    createExtensionProjectVm.typePeriod = []
    createExtensionProjectVm.projectTypes = []
    createExtensionProjectVm.financiers = []
    createExtensionProjectVm.projectRoles = []
    createExtensionProjectVm.acUnits = []
    createExtensionProjectVm.projectStatusP = []
    createExtensionProjectVm.financiersArray = []
    createExtensionProjectVm.periodsArray = []
    createExtensionProjectVm.isTouchedPeriods = false
    createExtensionProjectVm.rangeType = GlobalConfig.periods.rangeType
    createExtensionProjectVm.startDate = null
    createExtensionProjectVm.endDate = null
    createExtensionProjectVm.minStartDate = moment().toDate()
    createExtensionProjectVm.minEndDate = new Date()
    createExtensionProjectVm.isSaveButtonDisabled = false
    createExtensionProjectVm.isFeedback = currentUser.isFeedback
    createExtensionProjectVm.dt_start = $cookies.get('wp_start')
    createExtensionProjectVm.dt_end = $cookies.get('wp_end')
    
    // createExtensionProjectVm.hoursChildren = 0
    createExtensionProjectVm.hoursChildren = GlobalConfig.hoursChildren.generalProject

    createExtensionProjectVm.funSelectedPeriod = funSelectedPeriod
    createExtensionProjectVm.funSelectedFinancier = funSelectedFinancier
    createExtensionProjectVm.hasError = hasError
    createExtensionProjectVm.showErrorMessages = showErrorMessages
    createExtensionProjectVm.addExtensionProject = addExtensionProject
    createExtensionProjectVm.addActivityProject = addActivityProject
    createExtensionProjectVm.validateForm = validateForm
    createExtensionProjectVm.validateForma = validateForma
    createExtensionProjectVm.validateCheklistPeriods = validateCheklistPeriods
    createExtensionProjectVm.startDateChange = startDateChange
    createExtensionProjectVm.cleanRangeType = cleanRangeType
    createExtensionProjectVm.close = close

    createExtensionProjectVm.updateRangeType = (val) => {
      createExtensionProjectVm.rangeType = val
      createExtensionProjectVm.periodsArray = []
      createExtensionProjectVm.startDate = null
      createExtensionProjectVm.endDate = null
    }
    createExtensionProjectVm.updateRangeData = (val) => {
      createExtensionProjectVm.periodsArray = val['periods']
      createExtensionProjectVm.startDate = val['dates'][0]
      createExtensionProjectVm.endDate = val['dates'][1]
    }

    activate()

    function activate () {
      if (createExtensionProjectVm.isEditing) {
        createExtensionProjectVm.workplanTeacherActivityId = $stateParams.workplanTeacherActivityId
        createExtensionProjectVm.activityId = GlobalConfig.minorActivityId.extensionProjectParent
        createExtensionProjectVm.createOrEdit = 'Editar'
        createExtensionProjectVm.createOrEditMV = texts.editDialog
        createExtensionProjectVm.textCreateOrEdit = texts.modified
        getDataProject()
      }

      if (createExtensionProjectVm.idParent) {
        createExtensionProjectVm.workplanTeacherActivityId = createExtensionProjectVm.idParent.children.workplanTeacherActivityId
        if (createExtensionProjectVm.idParent.children !== 'ADD') {
          createExtensionProjectVm.createOrEdit = 'Editar'
          createExtensionProjectVm.createOrEditMV = texts.editDialog
          createExtensionProjectVm.textCreateOrEdit = texts.modified
          setValues(createExtensionProjectVm.idParent.children, createExtensionProjectVm.idParent.hoursChildren)
        } else {
          createExtensionProjectVm.hoursChildren = (createExtensionProjectVm.idParent.hoursChildren ? createExtensionProjectVm.idParent.hoursChildren : 0)
        }
      }

      WorkPlanSrv.getDataFormProjectsExtension.getList(post).$promise.then(
        dataReturn => {
          if (dataReturn.status) {
            loadData(dataReturn)
          } else {
            console.log('Comunications problem')
          }
        },
        data => {
          console.log(data)
        }
      )
    }

    function loadData (data) {
      createExtensionProjectVm.financiers = data.listFinancial
      createExtensionProjectVm.projectTypes = data.listInternalProject.items
      createExtensionProjectVm.projectRoles = data.listRole.items
      createExtensionProjectVm.assocProposals = data.listPorjectsFormulated
      createExtensionProjectVm.acUnits = data.academicUnit
      createExtensionProjectVm.typePeriod = data.listPeriods
    }

    function funSelectedPeriod (period, checked) {
      if (checked) {
        if (!createExtensionProjectVm.periodsArray.includes(period.periodId)) {
          createExtensionProjectVm.periodsArray.push(period.periodId)
        }
      } else {
        let index = createExtensionProjectVm.periodsArray.indexOf(period.periodId)
        if (index !== -1) {
          createExtensionProjectVm.periodsArray.splice(index, 1)
        }
      }
      createExtensionProjectVm.isTouchedPeriods = true
    }

    function funSelectedFinancier (financier, checked) {
      if (checked) {
        if (!createExtensionProjectVm.financiersArray.includes(financier.financialId)) {
          createExtensionProjectVm.financiersArray.push(financier.financialId)
        }
      } else {
        let index = createExtensionProjectVm.financiersArray.indexOf(financier.financialId)
        if (index !== -1) {
          createExtensionProjectVm.financiersArray.splice(index, 1)
        }
      }
    }

    function startDateChange () {
      let m = moment(createExtensionProjectVm.startDate)
      createExtensionProjectVm.minEndDate = m.isValid() ? m/*.add(1, 'days')*/.toDate() : null
    }

    function hasError (input) {
      if (input.$invalid && (input.$dirty || input.$touched)) {
        return 'has-error'
      }
    }

    function showErrorMessages (input) {
      return input.$dirty || input.$touched
    }

    function validateForm (form) {
      return form.$invalid || createExtensionProjectVm.validateCheklistPeriods()
    }

    function validateForma (form) {
      return form.$invalid || createExtensionProjectVm.validateCheklistPeriods()
    }

    function validateCheklistPeriods () {
      return (createExtensionProjectVm.rangeType == 1 ? createExtensionProjectVm.periodsArray.length < 1 : false)
    }

    function close () {
      WorkPlanModalSrv.setVariable({status: false})
      return $mdDialog.hide()
    }

    function addExtensionProject (isExecution) {
      let origin = GlobalConfig.activityTypeId.originActivityPlanning
      if (isExecution) {
        origin = GlobalConfig.activityTypeId.originActivityExecution
      }
      createJson(origin)
    }

    function createJson (origin) {
      var project = {
        activityId: GlobalConfig.minorActivityId.extensionProjectParent,
        teacherId: post.teacherId,
        workplanId: post.workplanId,
        name: createExtensionProjectVm.title,
        description: createExtensionProjectVm.description,
        hoursPlanning: createExtensionProjectVm.plannedHours,
        porjectsFormulatedId: createExtensionProjectVm.assocProposal,
        itemRoleId: createExtensionProjectVm.projectRole,
        itemTypePorjectId: createExtensionProjectVm.projectType,
        academicUnitId: createExtensionProjectVm.acUnit,
        timeRangeTypeId: createExtensionProjectVm.rangeType,
        origin: origin,
        hoursChildren: parseInt(createExtensionProjectVm.hoursChildren),
        isFeedbackActivity: createExtensionProjectVm.isFeedback
      }

      // Financiadores
      var arrayFinancial = []
      for (var index in createExtensionProjectVm.financiersArray) {
        var temp = {
          financialId: createExtensionProjectVm.financiersArray[index]
        }
        arrayFinancial.push(temp)
      }
      project.financial = (arrayFinancial.length !== 0) ? arrayFinancial : null

      if (createExtensionProjectVm.isEditing) {
        project.workplanTeacherActivityId = createExtensionProjectVm.workplanTeacherActivityId
      }

      if (parseInt(createExtensionProjectVm.rangeType) === GlobalConfig.periods.rangeType) {
        var arrayPeriod = []
        for (var index in createExtensionProjectVm.periodsArray) {
          var temp = {
            periodId: createExtensionProjectVm.periodsArray[index]
          }
          arrayPeriod.push(temp)
        }
        project.periods = arrayPeriod
      } else {
        project.startDate = createExtensionProjectVm.startDate
        project.endDate = createExtensionProjectVm.endDate
      }
      createExtensionProjectVm.modalType = texts.modalTypeId.extensionProject
      addOrEditProject(project, createExtensionProjectVm.modalType)
    }

    function addOrEditProject (project, modalType) {
      let action = 'ADD'
      if (createExtensionProjectVm.workplanTeacherActivityId) {
        action = 'EDIT'
      }
      createExtensionProjectVm.isSaveButtonDisabled = true
      WorkPlanSrv.addActivityProjectExtension.save(project).$promise.then(function (dataReturn) {
        if (dataReturn.status) {
          project.workplanTeacherActivityId = dataReturn.workplanTeacherActivityId
          project.hoursPlanned = project.hoursPlanning
          if (isExtensionProject(modalType)) {
            getSendNotify(project.origin)
            confirmProjectAction(modalType)
          } else {
            WorkPlanModalSrv.setVariable({status: dataReturn.status, child: project, action: action})
            confirmProjectAction(modalType)
            return $mdDialog.hide()
          }
        } else {
          createExtensionProjectVm.isSaveButtonDisabled = false
          console.log('Error Comunications')
        }
      }, function (data) {
        createExtensionProjectVm.isSaveButtonDisabled = false
        console.log(data)
      })
    }

    function confirmProjectAction (modalType) {
      let header = {
        createOrEdit: createExtensionProjectVm.createOrEditMV,
        textCreateOrEdit: createExtensionProjectVm.textCreateOrEdit,
        itemName: createExtensionProjectVm.title,
        nameModal: (isExtensionProject(modalType) ? texts.modalTypeName.extensionProject : texts.modalTypeName.activity),
        modalType: modalType
      }
      WorkPlanModalSrv.setVariableSuccessDialog(header)
      WorkPlanModalSrv.successDialog(header).then((promise) => { })
    }

    function getDataProject () {
      let post = {
        workplanTeacherActivityId: parseInt(createExtensionProjectVm.workplanTeacherActivityId)
      }
      WorkPlanSrv.getProjectExtensionByActivityId.get(post).$promise.then(function (dataReturn) {
        if (dataReturn.status) {
          if (!dataReturn.data.parent) {
            createExtensionProjectVm.project = dataReturn.data.childs[0]
          } else {
            createExtensionProjectVm.project = dataReturn.data.parent
          }
          setValues(createExtensionProjectVm.project, createExtensionProjectVm.project.hoursChildren)
        } else {
          console.log('Comunications problem with the server')
        }
      }, function (data) {

      })
    }

    function setValues (project, hoursChildren) {
      const dateValueSetter = (date) => moment(date, 'YYYY-MM-DD').isValid() ? moment(date, 'YYYY-MM-DD').toDate() : null
      createExtensionProjectVm.title = project.name
      createExtensionProjectVm.acUnit = project.academicUnitId
      createExtensionProjectVm.assocProposal = project.projectFormulatedId
      createExtensionProjectVm.projectType = project.listItemProjectTypeId
      createExtensionProjectVm.projectRole = project.listItemProjectRoleId
      createExtensionProjectVm.description = project.description
      createExtensionProjectVm.rangeType = project.timeRangeTypeId
      createExtensionProjectVm.dt_start = dateValueSetter(project.startDate)
      createExtensionProjectVm.dt_end = dateValueSetter(project.endDate)
      createExtensionProjectVm.plannedHours = project.hoursPlanned
      createExtensionProjectVm.notification = Boolean(project.isNotification === 1)
      createExtensionProjectVm.periodsArray = []
      createExtensionProjectVm.selectedTypePeriod = {}
      createExtensionProjectVm.financiersArray = []
      createExtensionProjectVm.selectedFinancier = {}
      createExtensionProjectVm.hoursChildren = (hoursChildren ? hoursChildren : 0)

      if (createExtensionProjectVm.rangeType == GlobalConfig.periods.rangeType) {
        createExtensionProjectVm.periodsArray = project.periodId.split(',').map(id => {
          createExtensionProjectVm.selectedTypePeriod[Number(id)] = true
          return Number(id)
        })
      }

      if (project.financialSourceId) {
        createExtensionProjectVm.financiersArray = project.financialSourceId.split(',').map(id => {
          createExtensionProjectVm.selectedFinancier[Number(id)] = true
          return Number(id)
        })
      }

      if (project.startDate) {
        var startDateNew = moment(project.startDate, 'YYYY-MM-DD').toDate()
        if (startDateNew <= moment().toDate()) {
          createExtensionProjectVm.minStartDate = moment(project.startDate, 'YYYY-MM-DD').toDate()
        }
        startDateChange()
      }

      createExtensionProjectVm.isEditing = true
    }

    function addActivityProject (activity) {
      createJsonActivity()
    }

    function createJsonActivity () {
      let activity = {
        activityId: GlobalConfig.minorActivityId.extensionProjectChild,
        teacherId: post.teacherId,
        workplanId: post.workplanId,
        name: createExtensionProjectVm.title,
        description: createExtensionProjectVm.description,
        hoursPlanning: createExtensionProjectVm.plannedHours,
        parentActivityId: createExtensionProjectVm.idParent.workplanTeacherActivityIdParent,
        hoursChildren: createExtensionProjectVm.idParent.hoursChildren,
        timeRangeTypeId: createExtensionProjectVm.rangeType,
        isFeedbackActivity: createExtensionProjectVm.isFeedback
      }

      if (activity.hoursChildren == 0) {
        activity.hoursPlanning = 0
      }

      if (createExtensionProjectVm.rangeType === GlobalConfig.periods.rangeType) {
        var arrayPeriod = []
        var aux = []
        for (var index in createExtensionProjectVm.periodsArray) {
          var temp = {
            periodId: createExtensionProjectVm.periodsArray[index]
          }
          arrayPeriod.push(temp)
          aux.push(createExtensionProjectVm.periodsArray[index])
        }
        activity.periods = arrayPeriod
        activity.periodId = aux.join(',')
      } else {
        activity.startDate = createExtensionProjectVm.startDate
        activity.endDate = createExtensionProjectVm.endDate
      }
      if (createExtensionProjectVm.isEditing) {
        activity.workplanTeacherActivityId = createExtensionProjectVm.workplanTeacherActivityId
      }

      createExtensionProjectVm.modalType = texts.modalTypeId.activity
      addOrEditProject(activity, createExtensionProjectVm.modalType)
    }

    function isExtensionProject (value) {
      return value == texts.modalTypeId.extensionProject
    }

    function cleanRangeType () {
      if (parseInt(createExtensionProjectVm.rangeType) == GlobalConfig.periods.rangeType) {
        createExtensionProjectVm.startDate = null
        createExtensionProjectVm.endDate = null
      } else {
        createExtensionProjectVm.periodsArray = []
        createExtensionProjectVm.selectedTypePeriod = null
      }
    }

    function getSendNotify (origin) {
      let msg = 'El profesor ' + currentUser.dsFullname + ' ha registrado un nuevo proyecto interno en la etapa de '
      if (origin == GlobalConfig.activityTypeId.originActivityExecution)
        msg = msg+'ejecución.'
      else
        msg = msg+'planeación.'
      
      const data = {
        idTeacher: currentUser.teacherId,
        dsName: 'Notificación, se agregó o editó un proyecto interno',
        dsDescription: msg,
        idNotification_delivery_type: GlobalConfig.notificationType.inbox,
        is_grouped: 1
      }
      GlobalSrv.sendNotificationsEvaluatorsSubmodule(data)
    }
  }// FIN DEL CONSTRUCTOR

  preventInput (event) {
    var vKey = 86
    if (event.keyCode == vKey) {
      event.preventDefault()
    }
    return
  }
}

CreateExtensionProjectCtrl.$inject = ['$scope', '$timeout', '$mdDialog', '$stateParams', 'WorkPlanSrv', 'WorkPlanModalSrv', '$cookies', 'GlobalConfig', 'GlobalSrv']




// WEBPACK FOOTER //
// ./src/app/u-faculty/workplan/extensionVisibility/extensionProjects/create/createExtensionProjectCtrl.js